import './App.css';
import Home from './components/home/Home';
import './i18n';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
